// eslint-disable-next-line import/prefer-default-export
export const auctionLimitValueValidator = (t, minLimitValue, maxLimitValue) => (input) => {
    let err = null;
    const parsedInput = parseInt(input, 10);
    if (!input) {
        err = t('auction-limits.validation.auction-limit-value-empty');
    } else if (parsedInput < minLimitValue) {
        err = t('auction-limits.validation.auction-limit-value-lower-than-min', { minLimitValue });
    } else if (parsedInput > maxLimitValue) {
        err = t('auction-limits.validation.auction-limit-value-greater-than-max', { maxLimitValue });
    } else if (!input.match(/^\d+$/)) {
        err = t('auction-limits.validation.auction-limit-not-integer');
    }
    return err;
};
